import React from 'react'

const Checkboard = () => {
  return (
    <div className='checkboard'></div>
  )
}

export default Checkboard